import {Register} from "../../genes/Register"

export const Computable = {}

export const LazyObject = {}

export const LazyConst = Register.global("$hxClasses")["tink.core._Lazy.LazyConst"] = 
class LazyConst extends Register.inherits() {
	new(value) {
		this.value = value;
	}
	isComputed() {
		return true;
	}
	get() {
		return this.value;
	}
	compute() {
	}
	underlying() {
		return null;
	}
	static get __name__() {
		return "tink.core._Lazy.LazyConst"
	}
	static get __interfaces__() {
		return [LazyObject]
	}
	get __class__() {
		return LazyConst
	}
}


export const Lazy_Impl_ = Register.global("$hxClasses")["tink.core._Lazy.Lazy_Impl_"] = 
class Lazy_Impl_ {
	static get(this1) {
		this1.compute();
		return this1.get();
	}
	static get __name__() {
		return "tink.core._Lazy.Lazy_Impl_"
	}
	get __class__() {
		return Lazy_Impl_
	}
}


export const LazyFunc = Register.global("$hxClasses")["tink.core._Lazy.LazyFunc"] = 
class LazyFunc extends Register.inherits() {
	new(f, from = null) {
		this.f = f;
		this.from = from;
	}
	underlying() {
		return this.from;
	}
	isComputed() {
		return this.f == null;
	}
	get() {
		return this.result;
	}
	compute() {
		let _g = this.f;
		if (_g != null) {
			let v = _g;
			this.f = null;
			let _g1 = this.from;
			if (_g1 != null) {
				let cur = _g1;
				this.from = null;
				let stack = [];
				while (cur != null && !cur.isComputed()) {
					stack.push(cur);
					cur = cur.underlying();
				};
				stack.reverse();
				let _g = 0;
				while (_g < stack.length) {
					let c = stack[_g];
					++_g;
					c.compute();
				};
			};
			this.result = v();
		};
	}
	static get __name__() {
		return "tink.core._Lazy.LazyFunc"
	}
	static get __interfaces__() {
		return [LazyObject]
	}
	get __class__() {
		return LazyFunc
	}
}

